var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2C0.896875 2 0 2.89688 0 4V12C0 13.1031 0.896875 14 2 14H16C17.1031 14 18 13.1031 18 12V4C18 2.89688 17.1031 2 16 2H2ZM4 12H2V10C3.10313 10 4 10.8969 4 12ZM2 6V4H4C4 5.10313 3.10313 6 2 6ZM14 12C14 10.8969 14.8969 10 16 10V12H14ZM16 6C14.8969 6 14 5.10313 14 4H16V6ZM9 5C9.79565 5 10.5587 5.31607 11.1213 5.87868C11.6839 6.44129 12 7.20435 12 8C12 8.79565 11.6839 9.55871 11.1213 10.1213C10.5587 10.6839 9.79565 11 9 11C8.20435 11 7.44129 10.6839 6.87868 10.1213C6.31607 9.55871 6 8.79565 6 8C6 7.20435 6.31607 6.44129 6.87868 5.87868C7.44129 5.31607 8.20435 5 9 5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBill);
export default __webpack_public_path__ + "static/media/money-bill.6f1400021b50b40df5b2e898c5a1ac00.svg";
export { ForwardRef as ReactComponent };